import classNames from "classnames";
import scss from "@/styles/pages/webinars/image-hero.module.scss";

export const wrapper = classNames(
  // Mobile
  // Tablet
  // All
  "flex",
  "flex-row",
  "items-center",
  "pb-4",
  "z-10",
  "h-fit",
  scss["wrapper"]
);

// srcSet images
export const image = classNames(
  // Mobile
  // "mobile:w-full",
  // "mobile:h-auto",
  // Tablet
  // "tablet:h-auto",
  // All
  "w-full",
  "z-0"
);

export const content = classNames(
  // Mobile
  "mobile:text-start",
  // Tablet
  "tablet:text-center",
  // All
  "z-20"
);

export const subheading = classNames(
  // Mobile
  "mobile:w-full",
  "mobile:pt-2",
  "mobile:text-sm",
  // Tablet
  "tablet:pt-6",
  "tablet:text-2xl"
  // All
);
